import styled from "styled-components";

export const StyledCompleteLeakTestJob = styled.div``;

export const LabelText = styled.span`
  position: absolute;
  left: 0px;
  padding: 5px;
`
